export default __webpack_public_path__ + "static/media/shuffle.ff295ac2.svg";